Backbone = require 'backbone'

class RefinementContextLogger extends Backbone.View
  sortsApp = undefined
  dealsSearch = undefined
  paginatedDealsBuilder = undefined

  DEFAULT_CATEGORY = 'goods'

  events:
    'click .card-ui a': '_addLoggerEvent'

  initialize: ({@refinementUIAppInstance}) ->

  setSortsApp: (sorts) ->
    sortsApp ?= sorts

  setDealsSearch: (search) ->
    dealsSearch = search

  setPaginatedDealsBuilder: (paginatedBuilder) ->
    paginatedDealsBuilder = paginatedBuilder

  _addLoggerEvent: (event) ->
    eventDetails =
      deal:
        href: event.currentTarget.href
      category: @_getCategoryHierarchy()
      pagination:
        offset: @_getOffset()
        count: @_getDealsCount()
        page: @_getCurrentPageNumber()
        sort: @_getSort()
      selectedRefinements: @_getRefinements()

    OptimizeSuite.TrackingHub.add 'deal-card-click', eventDetails

  _getSort: ->
    if sortsApp?.sortToggleView?
      return sortsApp.sortToggleView.$el.val()

    @$el.find('#grpn-sorts-select').val()

  _getCategoryHierarchy: ->
    selectedRefinements = @refinementUIAppInstance?.selectedRefinements
    currentCategory = selectedRefinements?.category.selectedValues[0]

    categoryLogEntry =
      category: DEFAULT_CATEGORY
      id: DEFAULT_CATEGORY
      level: 1
    while currentCategory?
      categoryLogEntry.id = currentCategory.name
      currentDepth = ++categoryLogEntry.level
      categoryLogEntry["category#{currentDepth}"] = currentCategory.name

      currentCategory = currentCategory.selectedValues?[0]

    categoryLogEntry

  _getCurrentPageNumber: ->
    if paginatedDealsBuilder?
      return paginatedDealsBuilder.search.getPageNumber()

    if dealsSearch?
      return dealsSearch.getPageNumber()

    parseInt @$el.find('.pagination_links li.box').text(), 10

  _getOffset: ->
    if paginatedDealsBuilder?
      return paginatedDealsBuilder.search.getStartingIndex()

    if dealsSearch?
      return dealsSearch.getStartingIndex()

    parseInt @$el.find('.pagination .results').text(), 10

  _getDealsCount: ->
    if paginatedDealsBuilder?
      return paginatedDealsBuilder.search.getDealsCount()

    if dealsSearch?
      return dealsSearch.getDealsCount()

    range = @$el.find('.pagination .results').text().split(' of')[0].trim().split(' - ')
    range[1] - range[0] + 1

  _getRefinements: ->
    refinementList = []
    selectedRefinements = @refinementUIAppInstance?.selectedRefinements

    for refinementKey, {selectedValues} of selectedRefinements when refinementKey isnt 'category'
      for {name, friendlyNameShort} in selectedValues
        refinementList.push
          filter: refinementKey
          uuid: name
          value: friendlyNameShort

    refinementList

module.exports = RefinementContextLogger
